module.exports = __webpack_public_path__ + "static/media/img1.a350d8b8.jpg";